export default "__VITE_ASSET__0bd3da95__"